<template>
    <div>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Relatório de Consumo de Itens do Contrato
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label
                            >Contrato
                            <span class="text-danger">*</span></label
                        >
                        <b-form-input
                            type="text"
                            placeholder="Digite o código do contrato. Ex: CT001/26"
                            v-model="contrato"
                            @input="$v.contrato.$touch()"
                            :state="$v.contrato.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O código do contrato é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            mostrarModal: false,
            contrato: null
        }
    },

    validations: {
        contrato: {
            required
        }
    },

    methods: {
        abrir() {
            this.contrato = null
            this.$v.$reset()
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                return
            }

            this.$emit('filtrar', { contrato: this.contrato.trim() })
            this.fechar()
        }
    }
}
</script>
